import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeft } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <Helmet>
        <title>Página Não Encontrada - Prefeitura Municipal de Três Fronteiras</title>
        <meta name="description" content="A página que você está procurando não foi encontrada." />
      </Helmet>
      
      <div className="max-w-md w-full text-center">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="h-48 flex items-center justify-center bg-gradient-to-r from-blue-600 to-blue-800">
            <h1 className="text-9xl font-bold text-white">404</h1>
          </div>
          
          <div className="p-6">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Página Não Encontrada</h2>
            <p className="text-gray-600 mb-6">
              A página que você está procurando não existe ou foi movida.
            </p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link 
                to="/"
                className="inline-flex items-center px-4 py-2 bg-blue-600 border border-transparent rounded-md font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                <HomeIcon className="w-5 h-5 mr-2" />
                Voltar para a Página Inicial
              </Link>
              
              <button 
                onClick={() => window.history.back()}
                className="inline-flex items-center px-4 py-2 bg-gray-100 border border-gray-300 rounded-md font-semibold text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Voltar
              </button>
            </div>
          </div>
        </div>
        
        <div className="mt-8 text-gray-500">
          <p>
            Se você acredita que isso é um erro, entre em contato com o 
            <Link to="/contato" className="text-blue-600 hover:underline ml-1">
              suporte
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
}